import RouteAppShell from '@/common/components/app-shell/RouteAppShell.tsx';
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <RouteAppShell>
      <Navigate to='/work-orders' />
    </RouteAppShell>
  );
}
